import React, { useState, useEffect } from "react";
import {
  handleApiExceptions,
  generate_query_set,
  goTo,
  alertify,
} from "../../app_methods";
import { EaseTable } from "../../libs/EaseTable";
import { isMobile } from "react-device-detect";
import { OrderDetailsDrawer } from "./order_details_drawer";
import {
  getTransactionOrdersTableColumns,
  TransactionOrdersTableFilterNodes,
} from "./constants";
import { SmartCollectTransactionOrders } from "../../models";
import { connect } from "react-redux";
import { CreateOrderModal, BulkUploadModal, PaginationKaBaap } from "../Common";
import {
  toggleBulkOrderModalAction,
  toggleCreateOrderModalAction,
} from "../../redux/actions";
import { PermissionHoc } from "../HOC";
import FileSaver from "file-saver";

const TransactionOrders = (props) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const permissions = props.current_user.user.permissions;
  const virtualAccountSettings=props.current_user.smart_collect_virtual_account_settings
  const [activeOrder, setActiveOrder] = useState({});
  const [pagination, setPagination] = useState({
    pageSize: 15,
    current: 1,
    hasNext: true,
    showing: { from: 1, to: 15 },
  });
  const [filters, setFilters] = useState({});
  const [TransactionOrdersData, setTransactionOrdersData] = useState([]);
  const [isSaving, setIsSaving] = React.useState(false);

  const toggleDetailsDrawer = (data = {}) => {
    setActiveOrder(data);
    setShowDetailsDrawer(!showDetailsDrawer);
  };

  const prepFilters = (filters) => {
    let _filters = { ...filters };
    if (_filters.created_at && _filters.created_at.length) {
      _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
      _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
      delete _filters.created_at;
    }
    return _filters;
  };

  const toggleCreateOrderModal = (data = {}) => {
    setActiveOrder(data);
    props.toggleCreateOrderModal();
  };

  const fetchTransactionOrdersData = async (
    _pagination = pagination,
    _filters = filters
  ) => {
    if (!props.current_user.key) return;
    setIsTableLoading(true);
    const response = await SmartCollectTransactionOrders.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
    if (!response.success) {
      setIsTableLoading(false);
      handleApiExceptions(response);
      return;
    }
    let txn_order = generate_query_set(
      SmartCollectTransactionOrders,
      response.data.results
    );
    txn_order = txn_order.map((account) => {
      return { ...account, is_submerchant: !!_filters.submerchant_id };
    });
    if (activeOrder.id) {
      var orderData =
        txn_order.find(
          (transactionOrder) => transactionOrder.id == activeOrder.id
        ) || {};
      setActiveOrder(new SmartCollectTransactionOrders(orderData));
    }
    setTransactionOrdersData(txn_order);
    setPagination({ ..._pagination, ...response.data.pagination });
    setIsTableLoading(false);
  };

  const showVATransactions = (id) => {
    props.onTabRender("transactions");
    goTo(`/insta-collect/orders/${id}/transactions`, props.history, { id: id });
  };
  const handleTableChange = (tableInfo) => {
    if (tableInfo.trigger == "columns") return;
    let _pagination = tableInfo.pagination;
    if (tableInfo.trigger == "filters") _pagination.current = 1;
    setPagination(_pagination);
    setFilters(tableInfo.filters);
    fetchTransactionOrdersData(_pagination, tableInfo.filters);
  };

  const downloadReport = async () => {
    setIsDownloading(true);
    if (filters.created_at.length) {
      if (filters.created_at[1].diff(filters.created_at[0], "days") > 31) {
        handleApiExceptions(
          "This report can be downloaded for 31 days or less."
        );
        setIsDownloading(false);
        return;
      }
    }
    const response = await SmartCollectTransactionOrders.report_download({
      ...prepFilters(filters),
    });
    if (response.status != 200) {
      setIsDownloading(false);
      handleApiExceptions("Something went wrong !");
      return;
    }
    FileSaver.saveAs(response.data, `Insta Collect Order Statement.csv`);
    setIsDownloading(false);
  };

  const saveOrder = async (data) => {
    if (data.expiry_date)
      data.expiry_date = data.expiry_date.format("YYYY-MM-DD HH:mm:ss");
    setIsSaving(true);
    const order_transaction = new SmartCollectTransactionOrders(data);
    const response = await order_transaction.save();
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    fetchTransactionOrdersData(pagination, filters);
    props.toggleCreateOrderModal();
    alertify("Success", `Order created successfully.`, "success");
    setIsSaving(false);
  };

  const editOrder = async (data) => {
    if (data.expiry_date)
      data.expiry_date = data.expiry_date.format("YYYY-MM-DD HH:mm:ss");
    setIsSaving(true);
    const response = await SmartCollectTransactionOrders.editOrderApiCall(activeOrder.id,data);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    fetchTransactionOrdersData(pagination, filters);
    props.toggleCreateOrderModal();
    alertify("Success", `Order edited successfully.`, "success");
    setIsSaving(false);
  };

  const tableColumns = getTransactionOrdersTableColumns({
    toggleDetailsDrawer,
    toggleCreateOrderModal,
    virtualAccountSettings
  });
  const tableFilters = TransactionOrdersTableFilterNodes(props.current_user);

  useEffect(() => {
    props.onTabRender("orders");
    let defaultFilters = {};
    tableFilters.forEach((f) => (defaultFilters[f.field] = f.defaultValue));
    setFilters({ ...filters, ...defaultFilters });
    fetchTransactionOrdersData(
      { ...pagination },
      { ...filters, ...defaultFilters }
    );
  }, []);

  const onPageChange = (_pagination) => {
    setPagination({ ..._pagination });
    fetchTransactionOrdersData({ ..._pagination }, filters);
  };

  return (
    <div>
      <EaseTable
        className="TransactionOrders-table-wrapper"
        rowKey="uuid"
        loading={isTableLoading}
        data={TransactionOrdersData}
        columns={tableColumns}
        fixedSelectable={!isMobile}
        handleTableChange={handleTableChange}
        // pagination={pagination}
        // totalRecords={pagination.total}
        filterNodes={tableFilters}
        downloadable={true}
        onDownload={downloadReport}
        isDownloading={isDownloading}
      />
      <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
      <OrderDetailsDrawer
        visible={showDetailsDrawer}
        onClose={toggleDetailsDrawer}
        toggleDetailsDrawer={toggleDetailsDrawer}
        order={activeOrder}
        virtualAccount={activeOrder.virtual_account}
        current_user={props.current_user}
        showVATransactions={showVATransactions}
        fetchTransactionOrdersData={fetchTransactionOrdersData}
      />
      <CreateOrderModal
        visible={props.showCreateOrderModal}
        toggleCreateOrderModal={toggleCreateOrderModal}
        order={activeOrder}
        onSubmit={activeOrder.is_edit ? editOrder: saveOrder}
        loading={isSaving}
      />
      <BulkUploadModal
        history={props.history}
        visible={props.showBulkOrderModal}
        toggleBulkUploadModal={props.toggleBulkOrderModal}
        onSuccess={() => fetchTransactionOrdersData(pagination, filters)}
        type="instacollect_order"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
  showCreateOrderModal: state.uiReducer.showCreateOrderModal,
  showBulkOrderModal: state.uiReducer.showBulkOrderModal,
});

const mapDispatchToProps = (dispatch) => ({
  toggleCreateOrderModal: () => {
    dispatch(toggleCreateOrderModalAction());
  },
  toggleBulkOrderModal: () => dispatch(toggleBulkOrderModalAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHoc(TransactionOrders, "IC_ORDER_READ"));
